import React from 'react';
import { connect } from "react-redux";
import { IContent } from '../../../types';
import { withContent } from '../../../hoc/withContext';
import './Advantage.scss';

// @ts-ignore
import { currencyFormatter } from "@mooncake/utils";
import { formatLocale, fetchDisplayPrice } from '../../../utils';

import Loader from "../Loader/Loader";

interface IAdvantageProps {
  context?: IContent;
  info: {
    title: string;
    description: string;
    image: string;
    product_id?: string;
  };
  loading?: any;
  products?: any;
}

const Advantage = ({ context, info, loading, products }: IAdvantageProps) => {
  const { global } = context;
  const { image, title, description } = info;

  // @ts-ignore
  const currency = window.GeoRestrictedResources ? window.GeoRestrictedResources.STOREFRONT_CURRENCY_CODE : null;
  // @ts-ignore
  const locale = window.GeoRestrictedResources ? formatLocale(window.GeoRestrictedResources.STOREFRONT_CURRENT_LOCALE) : null;

  let product = info.product_id && products[info.product_id] ? products[info.product_id] : null;

  // Find the product if not master
  if (info.product_id && products && !products[info.product_id]) {
    const findProductFromVariant = Object.values(products).filter((product: any) => product.originalData.variants.filter((productVariant: any) => productVariant.id === info.product_id).length === 1);
    const productMaster = findProductFromVariant.length === 1 ? findProductFromVariant[0] : null;
    // @ts-ignore
    const productFound = productMaster ? productMaster.originalData.variants.filter((productVariant: any) => productVariant.id === info.product_id) : [];
    product = productFound.length === 1 ? productFound[0] : null;
  }

  const imagePath = require(`../../../assets/${image}`);
  const displayPrice = fetchDisplayPrice(product);

  return (
    <li className="advantage">
      <div className="advantage-container">
        <div className="advantage-title">{title}</div>
        <div className="advantage-image"><img src={imagePath} alt="" /></div>
        <div className="advantage-description-container">
          <div className="advantage-description">{description}</div>
          {info.product_id && !product && (
            <Loader minHeight="25px" />
          )}
          {currency && locale && product && displayPrice && (
            <div className="price">
              {displayPrice.promotionalPrice && (typeof displayPrice.promotionalPrice === "number" || typeof displayPrice.promotionalPrice === "string") && (
                <div className="price-after">
                  <div className="from">{global.from}</div>
                  <div className="amount">
                    {currencyFormatter(
                      displayPrice.promotionalPrice,
                      locale,
                      currency,
                      {
                        shouldKeepEmptyDecimals: false
                      }
                    )}
                  </div>
                </div>
              )}
              {displayPrice.regular && (typeof displayPrice.regular === "number" || typeof displayPrice.regular === "string") && displayPrice.regular !== displayPrice.promotionalPrice && (
                <div className="price-before">
                  {currencyFormatter(
                    displayPrice.regular,
                    locale,
                    currency,
                    {
                      shouldKeepEmptyDecimals: false
                    }
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </li>
  );
};

const mapStateToProps = (state: any) => ({
  loading: state.app.loading,
  products: state.app.products
});

export default connect(mapStateToProps)(withContent(Advantage));
